import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { PuntoRuta } from "./logic";
import { createSelectorRx, upDownItem } from "keautils";

import { RutaSucursalEdit } from "./edit";
const EditModal = RutaSucursalEdit;
type Entity = PuntoRuta;
export interface Props {
    value: Entity[];
    onChange: (x: Entity[]) => void;
    readonly?: boolean;
    error?: kea.FieldError;
}

export interface BotonesListaDeps {
    onEdit: (x: Entity) => void;
    onBorrar: (x: Entity) => void;
    onSubir: (x: Entity) => void;
    onBajar: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
function columnas(deps: BotonesListaDeps): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones([
        ...kea.columnaBotonesDefault(deps),
        {
            iconClass: fa("arrow-up"),
            onClick: deps.onSubir
        }, {
            iconClass: fa("arrow-down"),
            onClick: deps.onBajar
        }
    ]);
    return [
        botones,
        { title: "Segmento", cell: x => ({ data: x.NombreSegmento }) },
    ];
}

/**Establece las propiedades de descripcion para ser mostradas correctamente en el listado */
async function setDescripciones(x: Entity): Promise<Entity> {
    const segmento = await resources.Segmento.getMemo(x.IdSegmento);
    return { ...x, NombreSegmento: segmento.Nombre, IdSucursalOrigen: segmento.IdSucursalOrigen, IdSucursalDestino: segmento.IdSucursalDestino };
}

/**
* Listado de Punto
*/
export class PuntoList extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    onAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    onEdit = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    onBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.NombreSegmento);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    onSubir = async (item: Entity) => {
        const oldList = this.props.value;
        await this.props.onChange(upDownItem(oldList, oldList.indexOf(item), "up"));
    }

    onBajar = async (item: Entity) => {
        const oldList = this.props.value;
        await this.props.onChange(upDownItem(oldList, oldList.indexOf(item), "down"));
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.AgregarButton onClick={this.onAgregar} />
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutas/edit/puntos/list.tsx